import { DeliverablesTableConfig } from "../scripts/deliverables-tracker.objects";
import { DeliverablesTable } from "../scripts/deliverables-tracker.table";

export class EditDeliverablesPage {
    deliverablesTableConfig: DeliverablesTableConfig;
    deliverablesTable: DeliverablesTable;

    constructor(deliverableUserGuideLink: string = "") {
        $(() => {
            let foundUserGuideLink = "";
            if (deliverableUserGuideLink) foundUserGuideLink = deliverableUserGuideLink;

            this.deliverablesTableConfig = {
                getDeliverablesRoute: "/secure/deliverables-tracker/edit-deliverables/edit-deliverables?handler=Deliverables",
                tableContainerId: "deliverables-content",
                loadingContainerId: "loading-content-container",
                loadedContentId: "loaded-deliverables-content",
                isEditable: true,
                tableVarName: "deliverablesTable",
                isAdmin: false,
                editModalId: "edit-deliverable-modal",
                postParentRoute: "/secure/list-management/list-management?handler=SaveParentDeliverables",
                postChildRoute: "/secure/list-management/list-management?handler=SaveChildDeliverables",
                getCommentsChildRoute: "/secure/list-management/list-management?handler=GetChildComments",
                postCommentChildRoute: "/secure/list-management/list-management?handler=SaveChildComment",
                commentModalId: "edit-comment-modal",
                attachmentModalId: "edit-attachments-modal",
                getAttachmentsRoute: "/secure/list-management/list-management?handler=GetAttachments",
                addAttachmentsRoute: "/secure/list-management/list-management?handler=AddAttachments",
                removeAttachmentsRoute: "/secure/list-management/list-management?handler=RemoveAttachment",
                addModalId: "add-new-modal",
                additionalInfoModalId: "deliverables-info-modal",
                viewDeliverableModalId: "",
                showUserGuide: true,
                userGuideLink: foundUserGuideLink
            }

            this.deliverablesTable = new DeliverablesTable(this.deliverablesTableConfig);
        });
    }

    closeAllModals() {
        $(".modal").modal('hide');
    }
}